// extracted by mini-css-extract-plugin
export default {"button":"ChoiceButton_button__0CNXy","active":"ChoiceButton_active__VhrWx"};